<div *ngFor="let message of messages.slice().reverse()" class="w-full flex">
  <div
    class="flex mb-2 sm:mb-4 w-full"
    [ngClass]="{ 'justify-end': isMyMessage(message), 'justify-start': !isMyMessage(message) }">
    <div class="max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg px-2 sm:px-4 py-2 relative">
      <div
        class="p-2 sm:p-3 rounded-lg shadow-md overflow-hidden"
        [ngClass]="isMyMessage(message) ? 'bg-blue-500 text-white' : 'bg-gray-300 text-gray-800'">
        <div class="flex items-start justify-between w-full">
          <div class="w-full">
            <span class="font-medium text-base">{{ message.userName }}</span>
            <p class="mt-1 break-words text-base" [innerHTML]="message.text"></p>

            <div *ngIf="message.attachments && message.attachments.length > 0" class="mt-2 grid gap-2">
              <mat-chip
                *ngFor="let attachment of message.attachments"
                clickable
                class="cursor-pointer bg-gray-200 text-gray-700"
                (click)="getAttachmentFile(questionId, message.id, attachment)">
                {{ attachment.fileName }} | {{ attachment.fileSize | fileSize }}
              </mat-chip>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-between text-xxs sm:text-xs mt-1">
          <span class="text-sm">{{ getTimeString(message.date) }}</span>
          <mat-icon class="flex justify-center items-center text-md" *ngIf="message.error" style="color: red">
            error_outline
          </mat-icon>
          <mat-icon class="flex justify-center items-center text-md" *ngIf="message.isSending && !message.error">
            schedule
          </mat-icon>
          <mat-icon
            class="flex justify-center items-center text-md"
            *ngIf="!message.isSending && !message.error"
            [ngClass]="{ done_all: message.read, done: !message.read }">
            {{ message.read ? 'done_all' : 'done' }}
          </mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>
